(ns app.front.dashboard.licencing
  (:require [app.front.dashboard.common :as dashboard-common]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [core.front.session :as session]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::queue-fetch-licence-count
  (fn [{:keys [db]} _]
    (if (:session/user db)
      {:dispatch [::fetch-licence-count]}
      {:async-flow {:rules [{:when     :seen-any-of?
                             :events   [::session/restored-session]
                             :dispatch [::fetch-licence-count]
                             :halt?    true}]}})))


(rf/reg-event-fx ::fetch-licence-count
  (fn [_ _]
    {:comm/command {:command    :licence/licence-count
                    :method     :get
                    :on-success [::fetch-licence-count.success]}}))


(rf/reg-event-db ::fetch-licence-count.success
  (fn [db [_ _ {:keys [count]}]]
    (assoc db ::licence-count count)))


(rf/reg-sub ::licence-count
  :-> ::licence-count)


(rf/reg-sub ::show-dashlet?
  :<- [::licence-count]
  :-> (every-pred some? pos?))


(defn dashboard-section [tr]
  (let [count (<sub [::licence-count])]
    [:section.dashlet
     [:h2 (tr [:licencing/licencing])]
     [dashboard-common/link-box-container {:class "justify-between"}
      [dashboard-common/link-box-with-number {:title    (tr [:licencing/open-search])
                                              :href     (href/href :view/licence-search)
                                              :loading? (nil? count)}
       count]]]))
